"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return Info;
    }
});
var _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function Info(props) {
    return /*#__PURE__*/ _react.createElement("svg", _extends({
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), /*#__PURE__*/ _react.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.9497 5.05025C12.2161 2.31658 7.78392 2.31658 5.05025 5.05025C2.31658 7.78392 2.31658 12.2161 5.05025 14.9497C7.78392 17.6834 12.2161 17.6834 14.9497 14.9497C17.6834 12.2161 17.6834 7.78392 14.9497 5.05025ZM3.63604 3.63604C7.15076 0.12132 12.8492 0.12132 16.364 3.63604C19.8787 7.15076 19.8787 12.8492 16.364 16.364C12.8492 19.8787 7.15076 19.8787 3.63604 16.364C0.12132 12.8492 0.12132 7.15076 3.63604 3.63604Z"
    }), /*#__PURE__*/ _react.createElement("rect", {
        x: "9",
        y: "5",
        width: "2",
        height: "2"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "M8 9H11V13H12V15H9V11H8V9Z"
    }));
}

//# sourceMappingURL=Info.js.map